export enum ContractPensionModel {
  Annual = "Annual",
  Months = "Months"
}
